/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Jobticket_Order_MissingInputs */



/**

* @param {Validation_Jobticket_Order_MissingInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const validation_jobticket_order_missing = /** @type {((inputs?: Validation_Jobticket_Order_MissingInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Jobticket_Order_MissingInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Bitte geben Sie zuerst ein Bestelldatum an.")
});